<template>
  <section class="blaFooter">
    <div class="row">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row">
          <div class="col-12 col-md-3 claFooterColumn text-xs-center">
            <img
              :src="require('@/assets/img/skillers_logo_new_white.png')"
              alt="skillersLogo"
              class="mb-3 img-fluid"
            />
            <div class="blaFooterAlt">2021© angoleegyetem kft.</div>
          </div>
          <div class="col-3 col-md-3">
            <!-- <div class="blaFooterTitle">Skillers</div>
            <ul>
              <li>
                <!-- <a
                  href="javascript:void(0)"
                  @click="$router.push({ name: 'packages' })"
                >
                  Csomagok
                </a> -->
              <!-- </li>
              <li> -->
                <!--<a-->
                <!--  href="https://play.google.com/store/apps/details?id=skillers.app"-->
                <!--  target="_blank"-->
                <!--&gt;-->
                <!--  Google Play-->
                <!--</a>-->
                <!-- <a href="javascript:void(0)" @click="goToPlayStore">
                  Google Play
                </a> -->
              <!-- </li>
              <li> -->
                <!--<a-->
                <!--  href="https://apps.apple.com/us/app/skillers/id1479188539?itsct=apps_box&itscg=30200"-->
                <!--  target="_blank"-->
                <!--&gt;-->
                <!--  Apple Appstore-->
                <!--</a>-->
                <!-- <a href="javascript:void(0)" @click="goToAppStore">
                  Apple Appstore
                </a> -->
              <!-- </li>
            </ul> --> 
          </div>
          <div class="col-8 col-md-3">
            <div class="blaFooterTitle">Hasznos információk</div>
            <ul>
              <li>
                <a href="javascript:void(0)" @click="goToEEgyetemAbout">
                  Rólunk
                </a>
              </li>
              <li>
                <a
                  href="https://admin.skillers.hu/skillers_gdpr_20210630.pdf"
                  target="_blank"
                >
                  Adatvédelmi nyilatkozat
                </a>
              </li>
              <li>
                <a
                  href="https://admin.skillers.hu/skillers_aszf.pdf"
                  target="_blank"
                >
                  ÁSZF
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-3 text-xs-center">
            <div class="blaFooterTitle">Kövess minket</div>
            <div class="d-inline">
              <img
                :src="
                  require('@/assets/images/iconfacebook-960D9156-EA55-4BEF-BDD2-CB3180B1B188.png')
                "
                alt="facebook"
                class="img-fluid clickable mr-3"
                @click="goToFacebookPage"
              />
            </div>
            <div class="d-inline">
              <img
                :src="
                  require('@/assets/images/iconinstagram-A8A97B52-7F0E-46B5-86A4-C9892F6DFE2B.png')
                "
                alt="instagram"
                class="img-fluid clickable"
                @click="goToInstagramPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    goToFacebookPage() {
      location.replace('https://hu-hu.facebook.com/angoleegyetem');
    },
    goToInstagramPage() {
      location.replace('https://www.instagram.com/eegyetem.hu/');
    },
    goToEEgyetemAbout() {
      location.replace('https://e-egyetem.hu/rolunk/');
    },
    goToAppStore() {
      location.replace(
        'https://apps.apple.com/us/app/skillers/id1479188539?itsct=apps_box&itscg=30200'
      );
    },
    goToPlayStore() {
      location.replace(
        'https://play.google.com/store/apps/details?id=skillers.app'
      );
    },
  },
  props: {},
  mounted: () => ({}),
};
</script>
